import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import '../../css/frontend/information-page.css';
import { FaSignInAlt } from 'react-icons/fa';
/**
 * Information Page
 * Simplified class structure with readable and flexible block names.
 */
export default function Information() {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>SpaceTime Community | Information</title>
                <meta name="description"
                      content="Find the right section fast: Association, Lab, contact, membership, activities, and our social media."/>
                <meta property="og:title" content="SpaceTime | Information"/>
                <meta property="og:description"
                      content="Go straight to the Association or Lab and discover how to contact us, become a member, and see our activities."/>
                <meta property="og:url" content="https://spacetime.community/information"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            <div className="information-page">
                {/* Header Section */}
                <header className="header-block">

                    <h1 className="page-title">{t('INFORMATION_TITLE') || 'Information'}</h1>
                    {/*<p className="page-subtitle">{t('INFORMATION_SUBTITLE') || 'Choose where you want to go or use the quick actions below.'}</p>*/}
                </header>

                {/* Association and Lab Section */}
                <section className="navigation-block">
                    <div className="nav-grid">
                        <Link to='/association' className="nav-card association-card">
                            <div className="card-image-wrapper">
                                <img
                                    src="/img/information/association-preview.jpg"
                                    alt="Association preview"
                                    className="card-image"
                                />
                            </div>
                            <h2 className="card-title">{t('ASSOCIATION') || 'Association'}</h2>
                            <p className="card-text">
                                {t('ASSOCIATION_BLURB') || 'Who we are, mission, structure, and how we work together.'}
                            </p>
                            <span className="card-cta"><FaSignInAlt /></span>
                        </Link>

                        <Link to='/lab' className="nav-card lab-card">
                            <div className="card-image-wrapper">
                                <img
                                    src="/img/information/lab-preview.jpg"
                                    alt="Lab preview"
                                    className="card-image"
                                />
                            </div>
                            <h2 className="card-title">{t('LAB') || 'Lab'}</h2>
                            <p className="card-text">
                                {t('LAB_BLURB') || 'Tools, projects, open sessions, and how to use the space.'}
                            </p>
                            <span className="card-cta"><FaSignInAlt /></span>
                        </Link>
                    </div>
                </section>


                {/* Contact (single block) */}
                <section className="
                contact-block" aria-label={t('CONTACT_DETAILS') || 'Contact details'}>
                    {/*<h3 className="block-title">{t('HOW_TO_CONTACT_US') || 'Contact'}</h3>*/}

                    <article className="contact-panel">
                        {/* Phone */}
                        <div className="contact-row">
                            <div className="contact-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                                    <path
                                        d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.03-.24 11.36 11.36 0 003.56.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.56 1 1 0 01-.24 1.03l-2.21 2.2z"/>
                                </svg>
                            </div>
                            <div className="contact-body">
                                <h4 className="contact-title">{t('PHONE') || 'Phone'}</h4>
                                <a className="contact-link" href="tel:+306946618047">+30 694 661 8047</a>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="contact-row">
                            <div className="contact-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                                    <path
                                        d="M20 4H4a2 2 0 00-2 2v.4l10 6.25L22 6.4V6a2 2 0 00-2-2zm2 5.2L12.62 15a2 2 0 01-2.24 0L2 9.2V18a2 2 0 002 2h16a2 2 0 002-2V9.2z"/>
                                </svg>
                            </div>
                            <div className="contact-body">
                                <h4 className="contact-title">{t('EMAIL') || 'Email'}</h4>
                                <a className="contact-link"
                                   href="mailto:info@spacetime.community">info@spacetime.community</a>
                            </div>
                        </div>

                        {/* Address + Google Maps */}
                        <div className="contact-row map-row">
                            <div className="contact-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                                    <path
                                        d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 119.5 9 2.5 2.5 0 0112 11.5z"/>
                                </svg>
                            </div>
                            <div className="contact-body">
                                <h4 className="contact-title">{t('ADDRESS') || 'Address'}</h4>
                                <p className="contact-text">
                                    Mirarchou Dimitriou Koufitsa 18, Thessaloniki 546 35
                                </p>

                                <iframe
                                    title="SpaceTime Community map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3693.951888373663!2d22.951214!3d40.636494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a8398ab7ba5013%3A0x7e63bd6273299b20!2zU3BhY2VUaW1lIExhYiAtIM6nz4nPgc6_z4fPgc-Mzr3Ov8-C!5e1!3m2!1sen!2sgr!4v1762131958735!5m2!1sen!2sgr"
                                    width="100%"
                                    height="250"
                                    style={{border: 0, borderRadius: '0.5rem'}}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>

                        </div>

                        {/* Socials */}
                        <div className="contact-actions">
                            <div className="contact-socials">
                                <a className="social-pill" href="https://facebook.com/spacetime.community/"
                                   target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                        <path
                                            d="M13 10h2.5l.5-3H13V5.5c0-.9.2-1.5 1.5-1.5H16V1.1C15.6 1 14.7 1 13.7 1 11.6 1 10 2.5 10 5.2V7H7v3h3v9h3v-9z"/>
                                    </svg>
                                    <span>Facebook</span>
                                </a>
                                <a className="social-pill" href="https://instagram.com/spacetime.community"
                                   target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                        <path
                                            d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5.5A5.5 5.5 0 1017.5 13 5.5 5.5 0 0012 7.5zm6-1.75a1.25 1.25 0 11-1.25 1.25A1.25 1.25 0 0118 5.75zM12 10a3 3 0 11-3 3 3 3 0 013-3z"/>
                                    </svg>
                                    <span>Instagram</span>
                                </a>
                                <a className="social-pill" href="https://t.me/spacetime_community" target="_blank"
                                   rel="noopener noreferrer" aria-label="Telegram">
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                        <path
                                            d="M9.04 15.46l-.13 3.68a.8.8 0 001.27.65l2.87-2.09 3.98 2.92c.73.53 1.68.13 1.93-.74l3.56-12.2c.28-.97-.62-1.86-1.58-1.55L3.1 10.1c-1.02.33-1 1.8.04 2.09l4.86 1.35 11.33-7.1-10.29 9.02z"/>
                                    </svg>
                                    <span>Telegram</span>
                                </a>
                            </div>
                        </div>
                    </article>
                </section>


            </div>
        </>
    );
}
